<template>
  <v-container fluid fill-height class="worldmap">
    <v-layout row wrap fill-height>
      <v-flex md12>
        <v-card class="h-100" style="z-index: 0">
          <vl-map
            :load-tiles-while-animating="true"
            :load-tiles-while-interacting="true"
            data-projection="EPSG:4326"
            class="vlmap h-100"
            @click="mapClick"
          >
            <div class="detail-btn">
              

              <div>
                <v-btn-toggle class="type-btn" v-model="topType" mandatory>
                  <v-btn flat>
                    <v-icon>people_outline</v-icon>
                  </v-btn>
                  <v-btn flat>
                    <v-icon>flight_takeoff</v-icon>
                  </v-btn>
                </v-btn-toggle>
              </div>

              <div class="mapNav">
                <v-menu offset-y max-height="200">
                  <v-btn style="margin-right: 0;" color="white" slot="activator">{{ this.curYear }}</v-btn>
                  <v-list>
                    <v-list-tile
                      v-for="year in years"
                      :key="'year-' + year"
                      @click="updDirStat(year)"
                    >
                      <v-list-tile-title>{{ year }}</v-list-tile-title>
                    </v-list-tile>
                  </v-list>
                </v-menu>

                <v-menu offset-y>
                  <v-btn slot="activator" color="white">TOP {{statLimit}}</v-btn>
                  <v-list>
                    <v-list-tile
                      v-for="(item, index) in [5, 10, 15, 20]"
                      :key="index"
                      @click="statLimit = item"
                    >
                      <v-list-tile-title>{{ item }}</v-list-tile-title>
                    </v-list-tile>
                  </v-list>
                </v-menu>
              </div>


              <div class="mapNav">
                <v-btn small fab color="white" v-if="!showStat" @click="showMapHint()">
                  <v-icon>help_outline</v-icon>
                </v-btn>

                <v-btn small fab color="white" v-if="!showStat" @click="showStat = true">
                  <v-icon>list</v-icon>
                </v-btn>
              </div>

            </div>
            <v-card class="detail-card h-100" v-if="showStat">
              <v-toolbar dense color="white" class="elevation-1">
                <v-toolbar-title class="body-1">Статистика по отправлениям за год</v-toolbar-title>

                <v-spacer></v-spacer>
                <v-btn icon @click="showStat = false">
                  <v-icon>clear</v-icon>
                </v-btn>
              </v-toolbar>

              <v-data-table
                :headers="this.headersStat"
                :items="directionStatistic"
                hide-actions
                class="elevation-0"
              >
                <template slot="items" slot-scope="props">
                  <tr
                    :class="props.item.IATA === selectedDirection.IATA ? 'selDirection' : props.item.PaxCount === 0 ? 'grey--text' : ''"
                    @click="clickDirection(props.item)"
                  >
                    <td>{{props.item.AirportName}}</td>
                    <td>{{props.item.IATA}}</td>
                    <td class="ws-no">
                      {{props.item.FlightCount}}
                      <v-icon
                        title="Предыдущий период"
                        small
                        :class=" (props.item.FlightGrowth > 0) ? 'green--text' : 'red--text'"
                      >{{ (props.item.FlightGrowth > 0)? 'arrow_upward' : 'arrow_downward' }}</v-icon>
                      <span class="grey--text">{{props.item.FlightGrowth}} %</span>
                    </td>
                    <td class="ws-no">
                      {{props.item.PaxCount}}
                      <v-icon
                        title="Предыдущий период"
                        small
                        :class=" (props.item.FlightGrowth > 0) ? 'green--text' : 'red--text'"
                      >{{ (props.item.FlightGrowth > 0)? 'arrow_upward' : 'arrow_downward' }}</v-icon>
                      <span class="grey--text">{{props.item.PaxGrowth}} %</span>
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </v-card>

            <vl-view :zoom.sync="zoom" :center="airportPosition" :rotation.sync="rotation"></vl-view>

            <vl-feature
              :id="'line-string-' + i"
              :key="'line-string-' + i"
              v-for="(item, i) in mapsArray"
            >
              <vl-geom-line-string
                :coordinates="arc(parseFloat(airportDetails.long), parseFloat(airportDetails.lat), parseFloat(item.long), parseFloat(item.lat))"
              ></vl-geom-line-string>
              <vl-style-box>
                <vl-style-stroke
                  :color="item.IATA === selectedDirection.IATA ? '#ff9800' : item.PaxCount === 0 ? '#aaa' : '#2196f3'"
                  :width="1"
                ></vl-style-stroke>
              </vl-style-box>
            </vl-feature>

            <!-- interactions -->
            <vl-interaction-select :features.sync="selectedFeatures">
              <template slot-scope="select">
                <vl-style-box :z-index="1">
                  <vl-style-stroke color="#2196f3" :width="1"></vl-style-stroke>
                </vl-style-box>
              </template>
            </vl-interaction-select>
            <!--// interactions -->

            <vl-feature :id="'overlay-' + i" :key="'overlay-' + i" v-for="(item, i) in mapsArray">
              <vl-overlay
                positioning="top-center"
                :offset="[0, statLimit - i + 3]"
                :position="[parseFloat(item.long), parseFloat(item.lat)]"
              >
                <template slot-scope="scope">
                  <div class="overlay-content" @click="clickDirection(item)">
                    <v-card
                      :key="'overlay-' + i + '-card'"
                      v-if="item.IATA !== selectedDirection.IATA"
                    >
                      <v-card-text class="pa-1">{{ item.IATA }}</v-card-text>
                    </v-card>
                    <v-card
                      :key="'overlay-' + i + '-cardFull'"
                      v-if="item.IATA === selectedDirection.IATA"
                      style="z-index: 2;"
                    >
                      <v-card-text class="pa-1">
                        {{ item.AirportName }}
                        <br>
                        Пассажиров: {{ item.PaxCount }}
                        <br>
                        Рейсов: {{ item.FlightCount }}
                        <br>
                      </v-card-text>
                    </v-card>
                    <!-- <v-tooltip bottom :open-on-hover="false">
                      <v-card slot="activator">
                        <v-card-text class="pa-1">{{ item.IATA }}</v-card-text>
                      </v-card>
                      <div>
                        {{ item.AirportName }}
                        <hr>
                        Пассажиров: {{ item.PaxCount }}
                        <br>
                        Рейсов: {{ item.FlightCount }}
                      </div>
                    </v-tooltip>-->
                  </div>
                </template>
              </vl-overlay>
            </vl-feature>

            <vl-feature :id="'point-' + i" :key="'point-' + i" v-for="(item, i) in mapsArray">
              <vl-geom-point :coordinates="[parseFloat(item.long), parseFloat(item.lat)]"></vl-geom-point>
              <vl-style-box>
                <vl-style-circle :radius="(statLimit - i) * 2 || 2">
                  <vl-style-fill
                    :color="item.IATA === selectedDirection.IATA ? '#ff980065' : '#03a9f465'"
                  />
                  <vl-style-stroke
                    :color="item.IATA === selectedDirection.IATA ? '#ff9800' : '#2196f3'"
                    :width="1"
                  />
                </vl-style-circle>
              </vl-style-box>
            </vl-feature>
            <vl-feature id="point-main" key="point-main">
              <vl-geom-point
                :coordinates="[parseFloat(airportDetails.long), parseFloat(airportDetails.lat)]"
              ></vl-geom-point>
              <vl-style-box>
                <vl-style-circle :radius="3">
                  <vl-style-fill color="#fff"/>
                  <vl-style-stroke color="#4caf50" :width="1"/>
                </vl-style-circle>
              </vl-style-box>
            </vl-feature>

            <vl-layer-tile id="osm">
              <!-- <vl-source-sputnik></vl-source-sputnik> -->
              <!-- <vl-source-osm></vl-source-osm> -->
              <vl-source-xyz :url="url"></vl-source-xyz>
            </vl-layer-tile>
          </vl-map>
        </v-card>
      </v-flex>
    </v-layout>

    <div class="text-xs-center">
      <v-dialog v-model="dirStatPreloader" hide-overlay persistent width="300">
        <v-card color="blue" dark>
          <v-card-text>
            Загрузка данных
            <v-progress-linear indeterminate color="white" class="mb-0" height="3"></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>

    <v-dialog v-model="alert.visible" width="500">
      <v-card>
        <v-card-text>
          <p class="title">Статистика по отправлениям за год</p>
          <p>Отображаемая информация на карте - это статистика за выбранный год по всем совершенным рейсам отправления</p>
          <p>
            <v-icon>people_outline</v-icon>- Сортировка по пассажиропотоку
          </p>
          <p>
            <v-icon>flight_takeoff</v-icon>- Сортировка по количеству рейсов
          </p>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import arc from 'arc'
import store from '@/store'
export default {
  data() {
    return {
      url: 'https://mt.google.com/vt/lyrs=m&hl=ru&x={x}&y={y}&z={z}',
      alert: {
        visible: false,
        title: '',
        text: '',
      },
      curYear: new Date().getFullYear(),
      selectedDirection: {},
      selectedFeatures: [],
      topType: 0,
      statLimit: 15,
      zoom: 3,
      rotation: 0,
      geolocPosition: undefined,
      lineAccuracy: 50,
      showStat: false,
      headersStat: [
        {
          text: 'Аэропорт',
          align: 'left',
          sortable: false,
          value: 'AirportName',
        },
        {
          text: 'IATA',
          align: 'left',
          sortable: false,
          value: 'IATA',
        },
        {
          text: 'Рейсов',
          align: 'left',
          sortable: false,
          value: 'FlightCount',
        },
        {
          text: 'Пассажиров',
          align: 'left',
          sortable: false,
          value: 'PaxCount',
        },
      ],
    }
  },
  methods: {
    arc: function(sx, sy, ex, ey) {
      let generator = new arc.GreatCircle({ x: sx, y: sy }, { x: ex, y: ey })
      let line = generator.Arc(this.lineAccuracy, { offset: 10 })
      let json = line.json()
      return json.geometry.coordinates
    },
    dirStatUpdate: function() {
      store.dispatch('maps/updateDirectionStatistic')
    },
    pathHover() {
      //
    },
    clickDirection(direction) {
      this.selectedDirection = direction
      this.showStat = true
    },
    showMapHint() {
      this.alert.visible = true
    },
    mapClick() {
      if (!this.showStat) {
        this.selectedDirection = {}
      }
      this.showStat = false
    },
    updDirStat(year) {
      this.curYear = year
      store.dispatch('maps/updateDirectionStatistic', { year: year })
    },
  },
  computed: {
    years: function() {
      let d = new Date('2010')
      let first = d.getFullYear()
      let s = new Date()
      let second = s.getFullYear()
      let arr = []
      for (let i = second; i >= first; i--) arr.push(i)
      return arr
    },
    directionStatistic: {
      get() {
        let ds = []
        ds = store.getters['maps/getDirectionStatistic']
        let lines = []
        ds.forEach(element => {
          if (element.lat !== null && element.long !== null) {
            lines.push(element)
          }
        })
        return lines.sort((a, b) => b.PaxCount - a.PaxCount)
      },
      set(value) {
        store.commit('maps/setDirectionStatistic', value)
      },
    },
    mapsArray() {
      let ds = [...this.directionStatistic] || []
      switch (this.topType) {
        case 0:
          ds.sort((a, b) => b.PaxCount - a.PaxCount)
          break
        case 1:
          ds.sort((a, b) => b.FlightCount - a.FlightCount)
          break
        default:
          ds.sort((a, b) => b.PaxCount - a.PaxCount)
          break
      }
      let top = ds.slice(0, this.statLimit)
      if (this.selectedDirection.hasOwnProperty('IATA') && top.indexOf(this.selectedDirection) === -1) {
        top = [...top, this.selectedDirection]
      }
      return top
    },
    airportPosition: {
      get() {
        return store.getters['getAirportPosition']
      },
    },
    dirStatPreloader: function() {
      return store.getters['maps/getDirStatPreloader']
    },
    airportDetails: {
      get() {
        let detail = store.getters['getAirportDetails']
        this.center = [parseFloat(detail.long), parseFloat(detail.lat)]
        return detail
      },
      set(value) {
        store.commit('auth/setApDetail', value)
      },
    },
  },
  mounted: function() {
    store.commit('setPageTitle', 'Карта мира')
  },
}
</script>

<style>
.selDirection {
  color: #ff9800;
}

@media (max-width: 768px) {
    .worldmap {
      overflow:hidden;
    }
    .mapNav {
      display: flex;
      flex-direction: column;
    }
    .vlmap {
      margin-top:56px;
      height: calc(100vh - 56px);
    }
    .detail-card {
      width:100%;
    }
  }
  .vlmap {
      margin-top:0;
      height: 100vh;
    }


</style>
